module.exports = __webpack_public_path__ + "img/user-10.eed1903c.svg";